import { FC } from "react";

type Props = {
  gradientStart:string;
  gradientEnd:string;
  fontColor?:string;
}

export const ScoringPlace:FC<Props> = ({ gradientStart, gradientEnd, fontColor }) => (
  <li
    className={`
      relative overflow-hidden flex items-center
      px-4 py-1 bg-gradient-to-b from-white to-gray-300 text-lg rounded-lg mb-2 gap-6
    `}
    style={{ color: fontColor }}
  >
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{
        background: `linear-gradient(to right, ${gradientStart}, ${gradientEnd})`
      }}
    />
    <p className="w-8 z-10 font-bold">1st</p>
    <p className="z-10 flex-1 whitespace-nowrap text-ellipsis overflow-hidden">John Smith</p>
    <p className="z-10">4567</p>
  </li>
);

export const VoteResults:FC<Props> = ({ gradientStart, gradientEnd, fontColor }) => (
  <div
    className="
      relative w-72 overflow-hidden
      flex items-center justify-between gap-6 p-2
      shadow-lg rounded-xl
      bg-gradient-to-b from-white to-gray-300 
    "
    style={{ color: fontColor }}
  >
    <div
      className="h-full absolute top-0 left-0 rounded-xl"
      style={{
        width: '87%',
        background: `linear-gradient(to right, ${gradientStart}, ${gradientEnd})`
      }}
    />
    <h3 className="relative text-lg font-bold z-1">Jack Byrne</h3>
    <p className="relative text-xs font-bold z-1">87%</p>
  </div>
)
